import React from "react";
import GenericOrdersListing from "@Pages/OrderListing/GenericOrdersListing.js";
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import ChatPopup from "@Pages/GenericOrderChat/ChatPopup.jsx";
function ReleaseOrdersListing() {
  return (
    <GenericOrdersListing
      title="Released Orders"
      isReleased={true}
      isCanceled={false}
      readOnly={true}
      icon={AssignmentTurnedInRoundedIcon}
      ChatPopup={ChatPopup}
    />
  );
}

export default ReleaseOrdersListing;